import { palette } from '@busie/ui-kit'
import { styled } from '@mui/material/styles'

export default styled('div')<{ isStop: boolean }>(({ isStop }) => {
  return `
    height: 20px;
    width: 20px;
    background-color: ${isStop ? palette.black.plus100 : palette.red.main};
    border: 1px solid ${isStop ? palette.red.main : 'transparent'};
    border-radius: 50%;
    font-size: 11px;
    font-weight: 600;
    color: ${isStop ? palette.red.main : palette.black.plus100};
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  `
})
